import { ReactComponent as CalendarIcon } from '../../assets/icons/calendar.svg'

export default CalendarIcon
